import { render, staticRenderFns } from "./LocalUnit.vue?vue&type=template&id=12a212f1"
import script from "./LocalUnit.vue?vue&type=script&lang=js"
export * from "./LocalUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports